import axios from 'axios'
import baseInfo from '../http/baseUrl'

export function initDic() {

  let that = this
  getDicData('major', (dic) => {
    // that.major = dic
  })
}
function getDicData (dict,callback) {
  axios.get(baseInfo.baseUrl + '/dict/' + dict)
    .then(response => {
        if (response) {
          callback(response.data)
        }
    })
    .catch(e => {
      console.log('get_err', e);
    })
}
export function major(callback){
  getDicData('major', (dic) => {
    callback(dic)
  })
}
// 职位类别
export function post_type (callback) {
  getDicData('post_type', (dic) => {
    callback(dic)
  })
}
// 学历
export function education(callback) {
  getDicData('education', (dic) => {
    callback(dic)
  })
}
// 地区
export function region(callback) {
  getDicData('region', (dic) => {
    callback(dic)
  })
}
// 技能标签
export function skill(callback) {
  getDicData('skill', (dic) => {
    callback(dic)
  })
}


export default {
  major: major,
  post_type: post_type,
  education: education,
  region: region,
  skill: skill,
  initDic: initDic
}



// WEBPACK FOOTER //
// ./src/tool/dicManager.js